import { API_URL } from "@/config";
import axios from "axios";

const http = axios.create({ baseURL: API_URL, withCredentials: true });

export interface LenderOption { lender_id: number; lender_name: string; lender_code: string; }

export async function getLenders(): Promise<LenderOption[]> {
    const res = await http.get<LenderOption[]>("/lenders/list");
    return res.data;
}

export interface AssignSalespersonPayload {
    salesperson1Id?: number;
    salesperson1Name?: string;
    salesperson2Id?: number;
    salesperson2Name?: string;
}
export async function assignSalesperson(dealId: number, payload: AssignSalespersonPayload) {
    const res = await http.patch(`/deals/${dealId}/assign`, payload);
    return res.data;
}

export interface DeskDealPayload {
    locked?: boolean;
    selectedLenderId?: number;
    dealerRoom?: string;
}
export async function deskDeal(dealId: number, payload: DeskDealPayload) {
    const res = await http.patch(`/deals/${dealId}/desk`, payload);
    return res.data;
}

export async function getLenderDeals(status?: string) {
    const res = await http.get("/lenders/deals", { params: status ? { status } : {} });
    return res.data;
}

export async function getLenderDeal(dealId: number) {
    const res = await http.get(`/lenders/deals/${dealId}`);
    return res.data;
}

export async function lenderDecision(dealId: number, decision: "APPROVED" | "INFO_REQUESTED" | "DECLINED", notes?: string) {
    const res = await http.patch(`/lenders/deals/${dealId}/decision`, { decision, notes });
    return res.data;
}
